import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-registration-consent',
  templateUrl: './registration-consent.component.html',
  styleUrls: ['./registration-consent.component.css']
})
export class RegistrationConsentComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
